// retinol-landing.js

document.addEventListener('DOMContentLoaded', function () {

  // ─── Founder video: play / pause ───────────────────────────────────────────
  var videoThumb = document.querySelector('.rl-founder-video-thumb');
  var playBtn    = videoThumb && videoThumb.querySelector('[data-role="play-pause"]');

  if (videoThumb && playBtn) {
    var hostedVideo = videoThumb.querySelector('.rl-video-player');
    var externalUrl = videoThumb.dataset.videoUrl;

    if (hostedVideo) {
      // Shopify-hosted video — toggle play / pause in place
      playBtn.addEventListener('click', function () {
        if (hostedVideo.paused) {
          hostedVideo.play();
          playBtn.innerHTML  = '⏸';
          playBtn.setAttribute('aria-label', 'Pause video');
        } else {
          hostedVideo.pause();
          playBtn.innerHTML  = '▶';
          playBtn.setAttribute('aria-label', 'Play video');
        }
      });

      // Restore play icon when video ends
      hostedVideo.addEventListener('ended', function () {
        playBtn.innerHTML = '▶';
        playBtn.setAttribute('aria-label', 'Play video');
      });

    } else if (externalUrl) {
      // External URL (YouTube / Vimeo) — open in new tab
      playBtn.addEventListener('click', function () {
        window.open(externalUrl, '_blank');
      });
    }
  }

   // ─── Problem video: play / pause ───────────────────────────────────────────
  var problemPlayBtn = document.querySelector('[data-role="problem-play-pause"]');
  var problemVideo   = problemPlayBtn && document.querySelector('.rl-problem-video');

  if (problemPlayBtn && problemVideo) {
    problemPlayBtn.addEventListener('click', function () {
      if (problemVideo.paused) {
        problemVideo.play();
        problemPlayBtn.innerHTML = '⏸';
        problemPlayBtn.setAttribute('aria-label', 'Pause video');
      } else {
        problemVideo.pause();
        problemPlayBtn.innerHTML = '▶';
        problemPlayBtn.setAttribute('aria-label', 'Play video');
      }
    });
  }

  // ─── Value stack video: play / pause ───────────────────────────────────────
  var valuePlayBtn = document.querySelector('[data-role="value-stack-play-pause"]');
  var valueVideo   = valuePlayBtn && document.querySelector('.rl-value-stack-video');

  if (valuePlayBtn && valueVideo) {
    valuePlayBtn.addEventListener('click', function () {
      if (valueVideo.paused) {
        valueVideo.play();
        valuePlayBtn.innerHTML = '⏸';
        valuePlayBtn.setAttribute('aria-label', 'Pause video');
      } else {
        valueVideo.pause();
        valuePlayBtn.innerHTML = '▶';
        valuePlayBtn.setAttribute('aria-label', 'Play video');
      }
    });
  }

  // ─── Hero video: play / pause ──────────────────────────────────────────────
  var heroPlayBtn   = document.querySelector('[data-role="hero-play-pause"]');
  var heroVideo     = heroPlayBtn && document.querySelector('.rl-hero-image .rl-hero-video');

  if (heroPlayBtn && heroVideo) {
    heroPlayBtn.addEventListener('click', function () {
      if (heroVideo.paused) {
        heroVideo.play();
        heroPlayBtn.innerHTML = '⏸';
        heroPlayBtn.setAttribute('aria-label', 'Pause video');
      } else {
        heroVideo.pause();
        heroPlayBtn.innerHTML = '▶';
        heroPlayBtn.setAttribute('aria-label', 'Play video');
      }
    });
  }

  // ─── Star ratings → scroll to reviews (dynamic, no hardcoded section id) ─────
  // Any element marked data-role="reviews-link" (hero rating, trust-strip rating)
  // links to the reviews block, found by its stable class. Only activated when a
  // reviews section is actually present, so it never adds a new dead-click.
  var reviewsBlock  = document.querySelector('.rl-reviews-marquee');
  // Scroll to the top of the whole reviews section (so its heading shows), not
  // into the middle of the marquee.
  var reviewsTarget = reviewsBlock && (reviewsBlock.closest('.shopify-section') || reviewsBlock);
  var reviewLinks   = document.querySelectorAll('[data-role="reviews-link"]');

  if (reviewsTarget && reviewLinks.length) {
    var goToReviews = function () {
      // Offset by the live sticky-header height so the section heading isn't
      // hidden under the fixed nav (adapts to mobile/desktop automatically).
      var header = document.querySelector('sticky-header');
      var offset = (header ? header.offsetHeight : 0) + 16;
      var top = reviewsTarget.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    };

    reviewLinks.forEach(function (el) {
      el.classList.add('is-reviews-link');
      el.setAttribute('role', 'link');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', 'Read customer reviews');
      el.addEventListener('click', goToReviews);
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); goToReviews(); }
      });
    });
  }

  // ─── Reviews marquee: tap to pause/resume (kills dead-clicks on autoplay) ────
  // Desktop pauses on hover (CSS). Touch has no hover, so a tap toggles the paused
  // state — the marquee visibly stops, so the tap registers instead of being dead.
  var reviewsMarquee = document.querySelector('.rl-reviews-marquee');
  if (reviewsMarquee && window.matchMedia('(hover: none)').matches) {
    reviewsMarquee.addEventListener('click', function () {
      reviewsMarquee.classList.toggle('is-paused');
    });
  }

  // ─── Sticky CTA bar: show only when the hero's own CTA is out of view ────────
  // Keeps exactly one CTA on screen: the hero's inline CTA on the first screen,
  // the sticky bar once it scrolls away — or immediately if the hero CTA loads
  // below the fold (so non-scrollers always have a CTA). Also hides at the footer.
  var stickyBar   = document.querySelector('.rl-sticky-cta');
  var heroCta     = document.querySelector('.rl-hero-cta-group');
  var footerGroup = document.querySelector('.shopify-section-group-footer-group');

  if (stickyBar) {
    // If a hero CTA exists, assume it's on screen at first (hidden bar, no flash);
    // the observer corrects it if it's actually below the fold. If there's no hero
    // CTA on the page, fall back to the old behavior (bar shown unless at footer).
    var heroCtaVisible = !!heroCta;
    var footerVisible  = false;

    var updateSticky = function () {
      if (heroCtaVisible || footerVisible) {
        stickyBar.classList.add('rl-sticky-cta--hidden');
      } else {
        stickyBar.classList.remove('rl-sticky-cta--hidden');
      }
    };

    if (heroCta) {
      new IntersectionObserver(function (entries) {
        heroCtaVisible = entries[0].isIntersecting;
        updateSticky();
      }, { threshold: 0 }).observe(heroCta);
    }

    if (footerGroup) {
      new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        updateSticky();
      }, { threshold: 0 }).observe(footerGroup);
    }

    updateSticky();
  }

  $('a.rl-btn').on("click", function(e){
      e.preventDefault();
      let this_ = $(this);
      this_.addClass("loading");
      if($(this).attr('href').includes("/cart/")){
          $(".rl-hero-cta-group button").click();
          setTimeout(() => {
            this_.removeClass("loading");
          }, 1500);
      }
  })

});
